import React from 'react'
import ReactDOM from 'react-dom';
import Header from '../../../Components/Modules/Includes/Header'
import { Row, Col } from 'react-bootstrap'
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Route, withRouter } from 'react-router-dom';
import * as actions from '../../../Actions/';
import AdminCompany from './AdminCompany.js'
import { Doughnut } from 'react-chartjs-2';
import { Bar } from 'react-chartjs-2';
import { Line } from 'react-chartjs-2';
import Moment from 'react-moment';
import Paginate from '../../../Components/Modules/Helper/Paginate'
import {donwloadFile} from '../../../helpers/helper';

class AdminDashboard extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			companySearchText: '',
			companySortByNameDirection: true,
			companySortByCityDirection: false,
			companySortByJobDirection: false,
			companySortByManualDirection: false,
			companySortByPlanDirection: false,
			companySortBy: 'name'
		};
		this.companySearchText = this.companySearchText.bind(this);
		this.companySortBy = this.companySortBy.bind(this);
		this.openCompany = this.openCompany.bind(this);
	}
	openCompany(company) {
		this.props.history.push(`/admin-company/${company.companyId}`);
	}
	// get no. of manuals created
	totalMnualCreated() {
		let stats = this.props.stats ? this.props.stats.manual_stats : 0;
		return stats;
	}
	companySortBy(sortby) {
		switch (sortby) {
			case 'name':
				this.setState({ companySortBy: sortby, companySortByNameDirection: !this.state.companySortByNameDirection });
				break;
			case 'city':
				this.setState({ companySortBy: sortby, companySortByCityDirection: !this.state.companySortByCityDirection });
				break;
			case 'job':
				this.setState({ companySortBy: sortby, companySortByJobDirection: !this.state.companySortByJobDirection });
				break;
			case 'manual':
				this.setState({ companySortBy: sortby, companySortByManualDirection: !this.state.companySortByManualDirection });
				break;
			case 'plan':
				this.setState({ companySortBy: sortby, companySortByPlanDirection: !this.state.companySortByPlanDirection });
				break;
			//default : 

		}
	}
	clientData(check) {
		var clientArray;
		if (check == 'created') {
			clientArray = this.props.stats ? this.props.stats.client_created : 0;
		} else {
			clientArray = this.props.stats ? this.props.stats.client_cancelation : 0;
		}
		var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

		// get last 6 months
		var today = new Date();
		var d;
		var month;
		var months = [];
		for (var i = 5; i >= 0; i -= 1) {
			d = new Date(today.getFullYear(), today.getMonth() - i, 1);
			month = monthNames[d.getMonth()];
			let yr = d.getFullYear();
			months.push(yr + '-' + month);
		}
		// get first month of theese last six months
		var firstmonth = months[0];
		var month1 = 0, month2 = 0, month3 = 0, month4 = 0, month5 = 0, month6 = 0;
		if (clientArray.length != 0) {
			_.forEach(clientArray, function (dateCreated) {
				_.forEach(months, function (month) {
					if (dateCreated.indexOf(month) !== -1) {
						switch (month) {
							case months[0]:
								month1++;
								break;
							case months[1]:
								month2++;
								break;
							case months[2]:
								month3++;
								break;
							case months[3]:
								month4++;
								break;
							case months[4]:
								month5++;
								break;
							case months[5]:
								month6++;
								break;
						}
					}
				});
			});
		}
		return [
			month1, month2, month3, month4, month5, month6
		];
	}
	getCompanyData() {

		let that = this
		const {companies, companydetails, subsusers, subscriptions, alljobs, companyjobs} = this.props;

		let subsdetails = subsusers;

		var companyData = [];
		_.forEach(companies, function (company) {

			
			let data = {};
			// find subsciption plan of company
			let subsdetail = _.filter(subsdetails, { 'company_id': company._id });
			// console.log("company_______________", company, subsdetail[0])
			let planName = _.filter(subscriptions, { '_id': subsdetail[0].subscription_id })[0].label;
			// find no. of jobs


			// find company datail name, city etc
			let companydetail = _.filter(companydetails, { 'company_id': company._id });
			if (companydetail.length != 0) {
				data.companyId = company._id;
				data.companyName = company.name
				data.companyCity = "";
				data.companyState = "";
				data.companyCountry = "";
				data.companyPostcode = "";
				if (planName != '') {
					data.companyPlan = planName;
				}
				let jobsOfCompany = _.filter(companyjobs, { 'company_id': company._id });
				var count = 0;
				// _.forEach(jobsOfCompany, function (companyjob) {
				// 	let job = _.filter(alljobs, { 'simpro_id': parseInt(companyjob.job_id) });
				// 	if (job.length != 0) {
				// 		if (typeof job[0].pdf_key != "undefined") {
				// 			count++;
				// 		}
				// 	}
				// })
				let jobs = _.filter(alljobs,{ 'company_id': company._id })
				// data.companyJobs = jobsOfCompany.length
				// data.companyJobs = jobs.length
				data.companyJobs = company.no_of_jobs,
				data.projectAllowanceNew = company.subscription_history,
				data.companyMaulal = count;
				data.companyCity = companydetail[0].address ? companydetail[0].address.city : '-';
				data.companyState = companydetail[0].address ? companydetail[0].address.state : '-';
				data.companyCountry = companydetail[0].address ? companydetail[0].address.country : '-';
				data.companyPostcode = companydetail[0].address ? companydetail[0].address.postcode : '-';
				data.signupDate = <Moment format="D MMM YYYY" >{company.created_at}</Moment>;				

				const {trialEndDate, projectAllowance} = that._getSubscriptionInfo(company._id)

				data.trialEndDate = trialEndDate ? <Moment format="D MMM YYYY" >{trialEndDate}</Moment> : "-";
				data.projectAllowance = projectAllowance;
			}
			
			if (_.isEmpty(data) === false) {
				companyData.push(data);
			}
		});
		return companyData;
	}

	_getActiveSubscriptions  = (companyId) => {
		const {SubscriptionActive} = this.props;
		const subs_active = _.filter(SubscriptionActive, { 'company_id': companyId });
		return subs_active;
	}

	_getAllSubscriptions  = (companyId) => {
		const {subscriptionhistory} = this.props;
		const subs_histories = _.filter(subscriptionhistory, { 'company_id': companyId });
		return subs_histories;

	}

	_getSubscriptionInfo = (companyId) => {

		let info = {
			trialEndDate : '',
			projectAllowance : 0,
		}
		const subs_histories = this._getAllSubscriptions(companyId);
		if(subs_histories && subs_histories.length > 0){
			const activeSubscr = this._getActiveSubscriptions(companyId);
			if(activeSubscr){
				info.projectAllowance = _.sumBy(activeSubscr, function(o) { return o.allowance; });	
			}
			const trialSubscr = _.find(subs_histories, { 'amount': null });
			if(trialSubscr){
				info.trialEndDate = trialSubscr.end_date
			}	
		}
		return info
	}

	subsDatabreakdown() {
		let companyData = this.getCompanyData();
		var countStarter = 0;
		var countEssential = 0;
		var countEnterprise = 0;
		_.forEach(companyData, function (company) {
			let plan = company.companyPlan;
			if (plan.indexOf('Starter') !== -1) {
				countStarter++;
			} else if (plan.indexOf('Essential') !== -1) {
				countEssential++
			} else if (plan.indexOf('Enterprise') !== -1) {
				countEnterprise++;
			}
		});
		return [
			countStarter,
			countEssential,
			countEnterprise,
		];
	}
	manualBarData() {

	}
	companySearchText(e) {
		this.setState({ companySearchText: e.target.value },()=>{
			this.props.searchCompany(this.state.companySearchText)
		});
	}
	renderCompany() {
		var companyData = this.getCompanyData();
		// console.log("this is company data", companyData);
		// if (this.state.companySearchText) {
		// 	let exactText = this.state.companySearchText.toLowerCase();
		// 	companyData = _.filter(companyData, (company) => {
		// 		if (company.companyName.toLowerCase().indexOf(exactText) !== -1) {
		// 			return true;
		// 		}
		// 		return false;
		// 	});
		// }
		if (this.state.companySortBy) {
			let filterBy = this.state.companySortBy;
			switch (filterBy) {
				case 'name':
					companyData = _.sortBy(companyData, [function (o) { return o.companyName; }]);
					if (this.state.companySortByNameDirection === false) {
						companyData = companyData.reverse();
					}
					break;
				case 'city':
					companyData = _.sortBy(companyData, [function (o) { return o.companyCity; }]);
					if (this.state.companySortByCityDirection === false) {
						companyData = companyData.reverse();
					}
					break;
				case 'job':
					companyData.sort((a, b) => {
						return this.state.companySortByJobDirection ? b.companyJobs - a.companyJobs : a.companyJobs - b.companyJobs;
					});
					break;
				case 'manual':
					companyData.sort((a, b) => {
						return this.state.companySortByManualDirection ? b.companyMaulal - a.companyMaulal : a.companyMaulal - b.companyMaulal;
					});
					break;
				case 'plan':
					companyData = _.sortBy(companyData, [function (o) { return o.companyPlan; }]);
					if (this.state.companySortByPlanDirection === false) {
						companyData = companyData.reverse();
					}
					break;
				default:
					companyData = _.sortBy(companyData, [function (o) { return o.companyName; }]);
					if (this.state.companySortByNameDirection === false) {
						companyData = companyData.reverse();
					}
					break;
			}
		}
		if (_.isEmpty(companyData) === false) {
			return companyData.map((c, i) => {
				return (
					<tr key={`company-${c.companyId}`} onClick={(e) => this.openCompany(c)}>
						<td data-title="Company">{c.companyName}</td>
						<td data-title="Town">{c.companyCity}</td>
						<td data-title="#of Jobs">{c.companyJobs}</td>
						<td data-title="#Of Manuals">{c.companyMaulal}</td>
						
						<td data-title="Plan">
							{c.companyPlan}
						</td>
						<td data-title="#Of Manuals">{c.signupDate}</td>
						<td data-title="#Of Manuals">{c.trialEndDate}</td>
						<td data-title="#Of Manuals">{c.projectAllowanceNew}</td>
						{/*<td data-title="#Of Manuals">{c.subsStatus}</td>*/}
					</tr>
				);
			});
		} else {
			return (
				<div>
					<p className="no-data-table">company not found.</p>
				</div>
			);
		}
	}

	_getSystemLogs = () => {
		this.props.getSystemLogs({
			older: 24 * 60 * 60 * 1000,
		}).then(() => {
			donwloadFile(JSON.stringify(this.props.system_logs), `${(new Date).toString()}.log` )
		});
	}

	handlePageChange = (pageNumber) => {
		this.setState({activePage: pageNumber},()=>{
			if(this.state.companySearchText){
				this.props.searchCompany(this.state.companySearchText,this.state.activePage)
			}else{
				this.props.fetchLoginUserDetail(this.state.activePage);
			}
		});
	}
	render() {
		let companyList = this.renderCompany();
		let totalManual = this.totalMnualCreated();
		let subsDatabreakdown = this.subsDatabreakdown();
		let clientData = this.clientData('created');
		let clientDatadeleted = this.clientData('deleted');

		var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

		var today = new Date();
		var d;
		var month;
		var months = [];
		for (var i = 5; i >= 0; i -= 1) {
			d = new Date(today.getFullYear(), today.getMonth() - i, 1);
			month = monthNames[d.getMonth()];
			months.push(month);
		}
		const optionsClient = {
			title: {
				display: true,
				position: "top",
				fontSize: 18,
			},
			legend: {
				display: false,
			},
			scales: {
				yAxes: [{
					ticks: {
						beginAtZero: true,
					}
				}]
			}
		};
		const dataClient = {
			labels: months,
			datasets: [
				{
					fill: false,
					lineTension: 0.1,
					backgroundColor: '#93ca20',
					borderColor: '#93ca20',
					borderCapStyle: 'butt',
					borderDash: [],
					borderDashOffset: 0.0,
					borderJoinStyle: 'miter',
					pointBorderColor: '#93ca20',
					pointBackgroundColor: '#93ca20',
					pointBorderWidth: 1,
					pointHoverRadius: 5,
					pointHoverBackgroundColor: '#93ca20',
					pointHoverBorderColor: '#93ca20',
					pointHoverBorderWidth: 2,
					pointRadius: 1,
					pointHitRadius: 10,
					data: clientData
				}
			]
		};
		const dataCancelDokkit = {
			labels: months,
			datasets: [
				{
					backgroundColor: '#008ee4',
					borderColor: '#008ee4',
					borderWidth: 1,
					hoverBackgroundColor: '#008ee4',
					hoverBorderColor: '#008ee4',
					data: clientDatadeleted,
				}
			]
		};
		const optionsCancelDokkit = {
			title: {
				display: true,
				position: "top",
				fontSize: 18,
			},
			legend: {
				display: false,
			},
			scales: {
				yAxes: [{
					ticks: {
						beginAtZero: true,
						labelOffset: 10
					},
					gridLines: {
						offsetGridLines: false
					}
				}],
				xAxes: [{
					//barPercentage: 0.6,
				}]
			}
		};
		const optionsSubs = {
			title: {
				display: true,
				position: "top",
				fontSize: 18,
			},
			legend: {
				display: true,
				position: "bottom",
			}
		};
		const dataSubs = {
			labels: ['Starter', 'Essential', 'Enterprise'],
			datasets: [
				{
					label: "# of Votes",
					data: subsDatabreakdown,
					backgroundColor: ['#92a4b0', '#ff9000', '#8dc34b'],
					hoverBackgroundColor: ['#92a4b0', '#ff9000', '#8dc34b']
				}
			]
		};
		return (
			<div>
				<Header />
				<div className="dashboard-page">
					<div className="right-content-dashboard active-dashboard">
						<div className="change-password-content">
							<Row>
								<form id="myForm" name="EditProfile">
									<Col md={4}>
										<div className="client_troffy orange">
											<div className="troffy-img">
												<img src="/images/users.png" alt="images/" />
											</div>
											<div className="troffy-content">
												<h4>{this.props.companydetails ? this.props.companydetails.length : ''}<span>Total Client</span></h4>
											</div>
										</div>
										<div className="client_troffy green">
											<div className="troffy-img">
												<img src="/images/trophy.png" alt="images/" />
											</div>
											<div className="troffy-content">
												<h4>{totalManual}<span>Manuals Created</span></h4>
											</div>
										</div>
										<div className="pie-chart-heading">
											<h3>Breakdown of subscriptions</h3>
										</div>
										<div className="pie-chart left-chart">
											<div className="lef-chart-box">
												<Doughnut data={dataSubs} options={optionsSubs} />
											</div>
										</div>

										<div className="client_troffy green" style={{cursor: "pointer"}}  onClick={this._getSystemLogs}>
											<div className="troffy-img">
												<img src="/images/debugging.png" width="60px" alt="Download Icon/" />
											</div>
											<div className="troffy-content">
												<h4><span>Download System Log (Info, Warn and Error)</span></h4>
											</div>
										</div>
									</Col>
									<Col md={8} className="paddl5px">
										<div className="pie-chart-heading">
											<h3>Client Churn</h3>
										</div>
										<div className="pie-chart">
											<Bar data={dataCancelDokkit} options={optionsCancelDokkit} maxBarThickness={10} />
										</div>
										<div className="pie-chart-heading">
											<h3>Client Uptake Over Time</h3>
										</div>
										<div className="pie-chart">
											<Line data={dataClient} options={optionsClient} />
										</div>
									</Col>
								</form>
							</Row>
						</div>
						<div className="dashboard-content-sec table-dashboard">
							<Row className="display-flex padd30">
								<Col sm={6} xs={6}>
									<h2>Companies</h2>
								</Col>
								<Col sm={3} className="hidden-xs"></Col>
								<Col sm={3} xs={6} className="text-right">
									<TextField
										fullWidth={true}
										floatingLabelText="Search..."
										type="text"
										onChange={this.companySearchText}
									/>
								</Col>
							</Row>
							<div className="dashboard-table-data">
								<table id="example" className="table responsive-table table-bordered dashboard-table" cellPadding="0" cellSpacing="0" width="100%">
									<thead>
										<tr>
											<th>Company <a onClick={(e) => this.companySortBy('name')}><i style={{ "padding": "5px" }} className="zmdi zmdi-unfold-more"></i></a></th>
											<th>City <a onClick={(e) => this.companySortBy('city')}><i style={{ "padding": "5px" }} className="zmdi zmdi-unfold-more"></i></a></th>
											<th>#of Jobs <a onClick={(e) => this.companySortBy('job')}><i style={{ "padding": "5px" }} className="zmdi zmdi-unfold-more"></i></a></th>
											<th>#Of Manuals <a onClick={(e) => this.companySortBy('manual')}><i style={{ "padding": "5px" }} className="zmdi zmdi-unfold-more"></i></a></th>
											<th>Plan <a onClick={(e) => this.companySortBy('plan')}><i style={{ "padding": "5px" }} className="zmdi zmdi-unfold-more"></i></a></th>

											<th>Signup date</th>
											<th>Trial end Date</th>
											<th>Project allowance</th>
										</tr>
									</thead>
									<tbody>
										{companyList}
									</tbody>
								</table>
								<center>
									<Paginate props={this.props} handlePageChange={this.handlePageChange} itemsCountPerPage={10} totalItemsCount={this.props.count ? this.props.count :0} pageRangeDisplayed={8} activePage={this.state.activePage}/>
								</center>
							</div>
							<div className="no-data-div">
								<p>Jobs have been imported but haven't been completed will show here.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state, props) => {
	console.log("state==>",state)
	return {
		subsusers: state.login.subsuser,
		companies: state.login.company,
		count: state.login.count,
		companydetails: state.login.companydetail,
		subscriptions: state.login.subscriptions,
		alljobs: state.login.alljobs,
		companyjobs: state.login.companyjobs,
		stats: state.login.stats,
		system_logs: state.system.logs,
		subscriptionhistory: state.login.subscriptionhistory,
		SubscriptionActive: state.login.SubscriptionActive,
	};
}
export default withRouter(connect(mapStateToProps, actions)(AdminDashboard));


// WEBPACK FOOTER //
// ./src/Components/Pages/Admin/AdminDashboard.js